import { Injectable } from '@angular/core';
import { RoleGuard } from '@cms_root/app/roles/base/guards/role.guard';
import { Role } from '@cms_root/app/roles/models/role';

@Injectable({ providedIn: 'root' })
export class AssetsRoleGuard extends RoleGuard {
  protected roles: Role[] = [Role.admin, Role.reviewer, Role.assetContentPublisher];
}
